import React, { Component } from 'react';
import Slider from 'rc-slider';
import { observer } from 'mobx-react';

import 'rc-slider/assets/index.css';
import './Volume.css';

import { DataStore } from '../DataStore';

@observer
class Volume extends Component {

    handleClick = (e) => {
        DataStore.silent = !DataStore.silent;
    }

    onChange = (value) => {
        if(value === 0) {
            DataStore.silent = true;
        }else{
            DataStore.silent = false;
        }
        DataStore.volume = value / 100;
    }

    render() {
        return (
            <div className="volume-box">
                <div className="volume-icon">
                    <button className={(DataStore.silent?"icon-mute":"icon-volume") + " iconfont"}
                         onClick={this.handleClick}></button>
                </div>
                <div className="volume-slider">
                    <Slider 
                        defaultValue={DataStore.volume * 100}
                        value={DataStore.volume * 100}
                        disabled={DataStore.disabled}
                        tipFormatter={null}
                        onChange={this.onChange}
                    />
                </div>
                
            </div>
        );
    }
}

export default Volume;


// WEBPACK FOOTER //
// ./src/components/Volume.js